(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.toggle.removeAttribute('aria-expanded');
        } else {
          this.toggle.removeAttribute('tabindex');
          this.toggle.setAttribute('aria-expanded', this.disclosure.open ? 'true' : 'false');
        }
      }

      open() {
        super.open();
        if (!window.matchMedia(theme.mediaQueries.md).matches) this.toggle.setAttribute('aria-expanded', 'true');
      }

      close() {
        super.close();
        if (!window.matchMedia(theme.mediaQueries.md).matches) this.toggle.setAttribute('aria-expanded', 'false');
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* Redesign 2026-10: mirror the menu's open state into aria-expanded on its toggles. */
  (function () {
    function sync(details) {
      var summary = details.querySelector(':scope > summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', details.classList.contains('is-open') ? 'true' : 'false');
    }
    function init() {
      var root = document.querySelector('.ei-hdr');
      if (!root || !('MutationObserver' in window)) return;
      var list = root.querySelectorAll('.main-menu__disclosure, .main-nav > li > details');
      var mo = new MutationObserver(function (records) {
        records.forEach(function (r) { sync(r.target); });
      });
      list.forEach(function (d) {
        sync(d);
        mo.observe(d, { attributes: true, attributeFilter: ['class', 'open'] });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
